import { deepFreeze } from 'utils/deepFreeze';

const initialState = deepFreeze({
  appleWalletApiError: false,
  loading: false,
  pkPass: null,
});

export default initialState;
